<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @isPickup="isPickup"
      @isReceive="isReceive"
      @detailPrint="detailPrint"
      @serviceFeedback="serviceFeedback"
      @abnormalRegister="abnormalRegister"
      @uploadPod="uploadPod"
      @packing="packing"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchIsPickUp="batchIsPickUp"
        @batchIsReceive="batchIsReceive"
        @batchDetailPrint="batchDetailPrint"
        @batchServiceFeedback="batchServiceFeedback"
        @batchAbnormalRegister="batchAbnormalRegister"
        @batchExport="batchExport"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <SetPickupDialog
      :visible.sync="pickupDialogOption.visible"
      :listOrder="pickupDialogOption.data"
      @reload="comitOk()"
    />
    <SetReceiveDialog
      :visible.sync="receiveDialogOption.visible"
      :listOrder="receiveDialogOption.data"
      @reload="comitOk()"
    />
    <ServiceFeedbackDialog
      :visible.sync="serviceFeedbackDialogOption.visible"
      :order="serviceFeedbackDialogOption.data"
    />
    <ServiceFeedbackBatchDialog
      :visible.sync="serviceFeedbackBatchDialogOption.visible"
      :listOrder="serviceFeedbackBatchDialogOption.data"
    />
    <AbnormalRegisterDialog
      :visible.sync="abnormalRegisterDialogOption.visible"
      :data="abnormalRegisterDialogOption.data"
      @reload="comitOk()"
    />
    <UploadPodDialog
      :visible.sync="uploadPodDialogOption.visible"
      :order="uploadPodDialogOption.data"
      @reload="comitOk()"
    />
    <PickerDialog
      :visible.sync="pickerDialogOption.visible"
      :dispatchOrderCode="pickerDialogOption.data"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import SetPickupDialog from '../set-pickup/dialog.vue'
import SetReceiveDialog from '../set-receive/dialog.vue'
import ServiceFeedbackDialog from '../service-feedback/dialog'
import ServiceFeedbackBatchDialog from '../service-feedback/batch/dialog.vue'
import AbnormalRegisterDialog from '../abnormal-register/dialog.vue'
import UploadPodDialog from '../upload-pod/dialog.vue'
import PickerDialog from '../packer/dialog.vue'
export default {
  components: {
    PageMain,
    PageHeader,
    SetPickupDialog,
    SetReceiveDialog,
    ServiceFeedbackDialog,
    ServiceFeedbackBatchDialog,
    AbnormalRegisterDialog,
    UploadPodDialog,
    PickerDialog,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      pickupDialogOption: {
        data: [],
        visible: false,
      },
      receiveDialogOption: {
        data: [],
        visible: false,
      },
      serviceFeedbackDialogOption: {
        data: {},
        visible: false,
      },
      serviceFeedbackBatchDialogOption: {
        data: [],
        visible: false,
      },
      abnormalRegisterDialogOption: {
        data: [],
        visible: false,
      },
      uploadPodDialogOption: {
        data: {},
        visible: false,
      },
      pickerDialogOption: {
        data: '',
        visible: false,
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carrierWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    isPickup(row) {
      if (!row) return
      this.pickupDialogOption = {
        data: [row],
        visible: true,
      }
    },
    batchIsPickUp() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return false
      this.pickupDialogOption = {
        data,
        visible: true,
      }
    },
    isReceive(row) {
      if (!row) return
      this.receiveDialogOption = {
        data: [row],
        visible: true,
      }
    },
    batchIsReceive() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return false
      this.receiveDialogOption = {
        data,
        visible: true,
      }
    },
    detailPrint(listCode) {
      this.$api.printPDF('/carrier/waybill/detail/print', { listCode })
    },
    batchDetailPrint() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return false
      this.detailPrint(data.map((item) => item.waybillDetailCode))
    },
    serviceFeedback(row) {
      if (!row) return
      this.serviceFeedbackDialogOption = {
        data: row,
        visible: true,
      }
    },
    batchServiceFeedback() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return
      this.serviceFeedbackBatchDialogOption = {
        data,
        visible: true,
      }
    },
    abnormalRegister(row) {
      if (!row) return
      this.abnormalRegisterDialogOption = {
        data: [row],
        visible: true,
      }
    },
    batchAbnormalRegister() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return
      this.abnormalRegisterDialogOption = {
        data,
        visible: true,
      }
    },
    uploadPod(row) {
      if (!row) return
      this.uploadPodDialogOption = {
        data: row,
        visible: true,
      }
    },
    packing(row) {
      if (!row) return
      this.pickerDialogOption = {
        data: row.dispatchOrderCode,
        visible: true,
      }
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
    comitOk() {
      this.$refs.main.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>
